import React from "react";
import UTurnSvg from "./u-turn.svg";

interface UTurnArrowProps {
    rotation?: number;
    count?: number;
    size?: number;
}

export const UTurnArrow: React.FC<UTurnArrowProps> = ({ rotation = 0, count, size = 60 }) => {
    return (
        <g transform={`rotate(${rotation})`}>
            <image href={UTurnSvg} width={size} height={size} x={-size / 2} y={-size / 2} />
        </g>
    );
};
